// Bundled by esbuild → app/assets/builds/application.js
import "@hotwired/turbo"
import { Application } from "@hotwired/stimulus"
import BooksIndexController from "./controllers/books_index_controller"

const application = Application.start()
application.debug = false
window.Stimulus = application

application.register("books-index", BooksIndexController)


